import { InjectionToken } from '@angular/core';

import { IShoppingCartSidebarCommandFacade } from '../../domain/ports/primary/shopping-cart.ports';
import { IPrewarmRepository } from '../../domain/ports/secondary/prewarm-repository.interface';

export const PREWARM_REPOSITORY = new InjectionToken<IPrewarmRepository>('PrewarmRepository');

export const SHOPPING_CART_SIDEBAR_FACADE = new InjectionToken<IShoppingCartSidebarCommandFacade>('ShoppingCartSidebarCommandFacade');
